import pickBy from 'lodash/pickBy';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

const defaultTransform = (value) => value;
const defaultValidate = () => true;

// these variables are used to keep singleton state until next tick where
// changes will be applied to URL
let timeout;
let changeset = {};

const useSearchParam = ({ key, validate = defaultValidate, transform = defaultTransform }) => {
  const transformRef = React.useRef(transform);
  const validateRef = React.useRef(validate);

  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = React.useMemo(() => queryString.parse(location.search), [location.search]);

  const setSearchParam = React.useCallback(
    (...args) => {
      const value = transformRef.current(...args);
      changeset[key] = validateRef.current(value) ? value : undefined;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        navigate(`?${queryString.stringify(pickBy({ ...searchParams, ...changeset }))}`);
        changeset = {};
      }, 0);
    },
    [key, navigate, searchParams],
  );

  return [searchParams[key], setSearchParam];
};

export default useSearchParam;
